/**
 * Created by Sandon on 2019-07-03.
 */
import state from './state'
import getters from './getters'
import mutation from './mutation'
import action from './action'

const store = {
  state,
  getters,
  mutations: {
    ...mutation
  },
  actions: {
    ...action
  }
}

export default store
